import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EmailRendererTestResult} from './email-renderer-test-result';
import {map, pluck} from 'rxjs/operators';
import {SerializedEmailRendererTestResult} from './serialized-email-renderer-test-result';

@Injectable()
export class EmailRendererTestResultService {

    constructor(private httpClient: HttpClient) {
    }

    /**
     *
     * @param id
     * @param client
     */
    public get(id: string, client: string): Observable<EmailRendererTestResult> {
        return this.httpClient.get<any>(`https://api.emailonacid.com/v5/email/tests/${id}/results/${client}`, {
            headers: {
                Authorization: `Basic ${btoa('Y1Koj3MKhYfiz5SAgGTBTluRJy3Z8P7nwJjT3UDC:7Fk0G2KVUiRaNnT6sH8v')}`
            }
        }).pipe(pluck(client), map((serializedEmailRendererResult: SerializedEmailRendererTestResult) => {
            return new EmailRendererTestResult({
                client: serializedEmailRendererResult.display_name,
                id: serializedEmailRendererResult.id,
                screenshot: serializedEmailRendererResult.screenshots.default,
                thumbnail: serializedEmailRendererResult.thumbnail
            });
        }));
    }
}
